import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  const location = useLocation();
  const { logout } = useAuthStore();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const isEditorPage = location.pathname.startsWith('/editor');

  return (
    <div className="min-h-screen flex flex-col">
      {/*
        #759 — WCAG 2.4.1 Bypass Blocks. First focusable element: a skip link that
        jumps past the header nav to the main content. Visually hidden until it
        receives keyboard focus (sr-only → focus:not-sr-only).
      */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>

      {!isEditorPage && <Header />}

      {/* Spacer for fixed header — editor has no marketing header */}
      {!isEditorPage && <div className="pt-[108px]" />}

      <main id="main-content" tabIndex={-1} className="flex-1">
        <Outlet context={{ setShowLogoutConfirm }} />
      </main>

      {!isEditorPage && <Footer />}

      {/* Logout Confirmation */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowLogoutConfirm(false)} />
          <div className="relative bg-slate-800 rounded-xl shadow-2xl border border-slate-700 w-full max-w-sm mx-4 p-6">
            <h3 className="text-lg font-semibold text-white mb-2">Log Out?</h3>
            <p className="text-sm text-slate-400 mb-6">
              Any unsaved design changes will be lost. Make sure to save your work before logging out.
            </p>
            <div className="flex items-center justify-end gap-3">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 text-sm font-medium text-slate-300 bg-slate-700 hover:bg-slate-600 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => { setShowLogoutConfirm(false); logout(); }}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-500 rounded-lg transition-colors"
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
